//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const AggregatePromotedPostsValues = {
  AmountSpent: 'AmountSpent',
  TotalClicks: 'TotalClicks',
  AverageCPC: 'AverageCPC',
  TotalImpressions: 'TotalImpressions',
  TotalRevenue: 'TotalRevenue',
  TotalROAS: 'TotalROAS',
};

export const AggregatePromotedPostsValueLabels = {
  [AggregatePromotedPostsValues.AmountSpent]: 'Amount Spent',
  [AggregatePromotedPostsValues.TotalClicks]: 'Total Clicks',
  [AggregatePromotedPostsValues.AverageCPC]: 'Average CPC',
  [AggregatePromotedPostsValues.TotalImpressions]: 'Total Impressions',
  [AggregatePromotedPostsValues.TotalRevenue]: 'Total Revenue',
  [AggregatePromotedPostsValues.TotalROAS]: 'Total ROAS',
};
